<template>
  <div class="timeline px-4">
    <div class="d-flex justify-space-between align-baseline">
      <h2 class="main-title">
        Pregledi za <span class="teal--text mr-4">{{petInfo.name}}</span>
      </h2>
      <v-btn small class="mx-1 orange darken-4 white--text" :to="'/Examination/?petId=' + $route.query.petId">
        <v-icon left> mdi-plus </v-icon>
        Pregled
      </v-btn>
    </div>
    <div class="main-container">
      <v-timeline>
        <div v-if="examinations && examinations.length">
        <v-timeline-item
          v-for="(examination, index) in examinations"
          :key="index"
          color="teal lighten-2"
          medium
          icon="mdi-paw"
        >
          <template v-slot:opposite class="d-flex flex-column">
            <v-btn depressed small class="text--white teal darken-2 printBtn" :to="'/Certificate/?petId=' + $route.query.petId + '&appointmentId=' + examination.appointmentId"
              >Štampa</v-btn
            >
            <v-btn depressed small class="text--white teal darken-2 ml-2" :to="'/Certificate/?mail=1&petId=' + $route.query.petId + '&appointmentId=' + examination.appointmentId"
              >Mail</v-btn
            >
          </template>
          <v-card class="elevation-0">
            <v-card-title class="timeline-card-title">
              <v-btn class="editBtn" text :to="'/Examination/?appointmentId=' + examination.appointmentId + '&petId=' + $route.query.petId"><v-icon color="orange" class="mr-2 white--text">mdi-folder-edit-outline</v-icon></v-btn>
              <span class="yellow--text mr-4">{{ examination.date | formatDate}}</span>
              <span class="green--text" v-if="examination.price">{{ examination.price }}din</span>
              <v-spacer></v-spacer>
              <v-icon class="removeExamination" @click="removeExamination(examination.appointmentId)">mdi-trash-can-outline</v-icon>
            </v-card-title>
            <v-card-text>
              <div class="examination">
                <div class="item" v-if="examination.anamneza">
                  <p class="examination-title">Anamneza</p>
                  <p>{{ examination.anamneza }}</p>
                </div>
                <div class="item" v-if="examination.klinickaSlika">
                  <p class="examination-title">Klinicka Slika</p>
                  <p>{{ examination.klinickaSlika }}</p>
                </div>
                <div class="item" v-if="examination.dijagnoza">
                  <p class="examination-title">Dijagnoza</p>
                  <p>{{ examination.dijagnoza }}</p>
                </div>
                <div class="item" v-if="examination.terapija">
                  <p class="examination-title">Terapija</p>
                  <p>{{ examination.terapija }}</p>
                </div>
                <div class="item" v-if="examination.napomena">
                  <p class="examination-title">Napomena</p>
                  <p>{{ examination.napomena }}</p>
                </div>
                <div class="item" v-if="examination.specijalneMetodeDijagnostike">
                  <p class="examination-title">
                    Specijalne Metode Dijagnostike
                  </p>
                  <p>{{ examination.specijalneMetodeDijagnostike }}</p>
                </div>
                <div class="item" v-if="examination.vaccine.name">
                  <p class="examination-title">Ime vakcine</p>
                  <p>{{ examination.vaccine.name }}</p>
                </div>
                <div class="item" v-if="examination.vaccine.type && examination.vaccine.name">
                  <p class="examination-title">Tip vakcine</p>
                  <p>{{ examination.vaccine.type }}</p>
                </div>
                <div class="item" v-if="examination.vaccine.date && examination.vaccine.name">
                  <p class="examination-title">Datum vakcinacije</p>
                  <p>{{ examination.vaccine.date| formatDate }}</p>
                </div>
                <div class="item" v-if="examination.vaccine.nextDate && examination.vaccine.name">
                  <p class="examination-title">Datum naredne vakcinacije</p>
                  <p>{{ examination.vaccine.nextDate | formatDate }}</p>
                </div>
                <div v-if="examination.files">
                  <a
                    class="d-block"
                    target="_blank"
                    v-for="(file, indexFile) in examination.files"
                    :key="indexFile"
                    :href="file.fullPath"
                    >{{file.fileName | getFileName}}</a
                  >
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-timeline-item>
        </div>
        <div v-else>
          <v-alert
          class="py-4"
            text
            dense
            color="teal"
            icon="mdi-information-outline"
            border="left"
          >
            <h4>Nema istorije</h4>
          </v-alert>
        </div>
      </v-timeline>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="290"
      >
      <v-card>
        <v-card-title class="headline">
        </v-card-title>
        <v-card-text class="subtitle-2">Da li sigurni da želite da izbrišete ovaj pregled?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            class="white--text"
            small
            @click="dialog = false"
          >
            Otkaži
          </v-btn>
          <v-btn
            color="teal darken-1"
            small
            @click="removeExaminationFromPopup()"
          >
            Izbriši
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from 'moment'

export default {
  name: "Timeline",
  data() {
    return {
      dialog: false,
      currentAppointmentId: null
    };
  },
  mounted () {
    this.$store.dispatch("getPet", this.$route.query.petId);
    this.$store.dispatch('getHistory', this.$route.query.petId );
  },
  components: {
  },
  computed: {
    ...mapState(["lang", "snackbar", "examinations", "petInfo"])
  },
  methods: {
    removeExamination (appointmentId) {
      this.currentAppointmentId = appointmentId
      this.dialog = true
    },
    removeExaminationFromPopup () {
      this.$store.dispatch('removeExamination', {appointmentId: this.currentAppointmentId, petId: this.$route.query.petId})
      this.dialog = false
    }
  },
  filters: {
    formatDate: (value) => {
      if (value)
        return moment(String(value)).format('YYYY-MM-DD');
        else {
          return ''
        }
    },
    getFileName (file) {
      if (file) {
        var name = file.split('____')
        name = name[0] + (name[2] ? name[2] : '')
        return name
      } else {
        return file
      }
    }
  }
}
</script>

<style lang="scss">
.theme--light.v-timeline::before {
  background: none!important;
}
.removeExamination {
  cursor: pointer;
  color: darkred!important;
}
.timeline {
  .v-card {
    background: rgba(10, 10, 10, 0.5);
  }
  .v-card__title {
    font-weight: bold;
    color: #b3b3b3;
  }
}
.examination {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  > div {
    flex: 0 0 48%;
    margin: 10px 1%;
    padding: 10px;
    border-radius: 4px;
  }
  > div.item {
    flex: 0 0 48%;
    margin: 10px 1%;
    background: #272727;
    padding: 10px;
    border-radius: 4px;
    P {
      color: #e9e9e9;
    }
    p.examination-title {
      font-weight: bold;
      color: #fff;
      font-size: 16px;
      margin-bottom: 5px;
    }
  }
}


@media (max-width: 768px) {
  .printBtn {
    display: none;
  }
  .v-timeline-item__divider {
    display: none!important;
  }
  .v-timeline-item__body {
    flex: 0 0 80%!important;
    max-width: 70%!important;
  }
  .v-timeline-item__opposite {
    text-align: center!important;
    max-width: 30%;
    flex: 0 0 30%!important;
    a {
      margin: 10px 0;
    }
  }
  .examination {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      flex: 0 0 100%;
      margin: 0;
    }
    > div.item {
      flex: 0 0 100%;
      margin: 10px 0;
      p {
        font-size: 12px;
      }
      .examination-title {
        font-size: 14px!important;
      }
    }
  }
  .timeline-card-title {
    justify-content: flex-end;
    > span {
      font-size: 12px;
    }
  }
  .editBtn {
    min-width: 35px!important;
    padding: 0!important;
  }
}
</style>